import React from "react";
import { useNavigate } from "react-router-dom";
import { Server, ArrowRight, CheckCircle2, AlertTriangle } from "lucide-react";
import { useServerStats, serverHealth, Spark } from "@/pages/admin/ServerStatus";

const tone = (pct) => (pct >= 85 ? "#DC2626" : pct >= 60 ? "#D97706" : "#1E9E2A");
const Mini = ({ label, pct, sub }) => (
  <div className="min-w-0">
    <div className="text-xs text-slate-500">{label}</div>
    <div className="font-display text-xl font-bold" style={{ color: tone(pct) }}>{pct}%</div>
    <div className="h-1.5 rounded-full bg-slate-100 mt-1 overflow-hidden"><div className="h-full rounded-full transition-all" style={{ width: `${Math.min(100, pct)}%`, background: tone(pct) }} /></div>
    <div className="text-[11px] text-slate-400 mt-1 truncate">{sub}</div>
  </div>
);

/** Quadro pequeno do Dashboard: saúde do servidor em tempo real (abre a tela Servidor). */
export const ServerMini = () => {
  const navigate = useNavigate();
  const { d, err } = useServerStats(15000);
  const h = serverHealth(d);
  return (
    <button onClick={() => navigate("/admin/servidor")} className="w-full text-left bg-white rounded-xl border border-slate-200 p-5 shadow-sm hover:shadow-md transition-all" data-testid="dashboard-server-card">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2 font-display font-bold text-slate-800"><Server className="h-5 w-5 text-[#1E9E2A]" /> Servidor</div>
        {d ? (
          <span className={`inline-flex items-center gap-1.5 text-xs font-bold px-2.5 py-1 rounded-full ${h.ok ? "bg-emerald-50 text-emerald-700" : "bg-red-50 text-red-700"}`}>
            {h.ok ? <CheckCircle2 className="h-3.5 w-3.5" /> : <AlertTriangle className="h-3.5 w-3.5" />} {h.txt}
          </span>
        ) : <span className="text-xs text-slate-400">{err || "Carregando…"}</span>}
      </div>
      {d && (
        <div className="mt-4 grid grid-cols-2 sm:grid-cols-5 gap-4 items-end">
          <Mini label="Processador" pct={d.cpu.pct} sub={`carga ${d.cpu.carga[0]}`} />
          <Mini label="Memória" pct={d.memoria.usada_pct} sub={`${Math.round(d.memoria.livre_mb / 1024)} GB livres`} />
          <Mini label="Disco" pct={d.disco.usado_pct} sub={`${d.disco.usado_gb} de ${d.disco.total_gb} GB`} />
          <div className="min-w-0">
            <div className="text-xs text-slate-500">Online agora</div>
            <div className="font-display text-xl font-bold text-slate-900">{d.online.m2}</div>
            <div className="text-[11px] text-slate-400 mt-1 truncate">{d.online.m15} em 15 min</div>
          </div>
          <div className="min-w-0 col-span-2 sm:col-span-1">
            <div className="text-xs text-slate-500 flex items-center justify-between">Acessos/min <span className="text-slate-400">{d.requisicoes.ultimos_5min} em 5 min</span></div>
            <Spark values={d.requisicoes.serie.map((x) => x.req)} height={36} />
          </div>
        </div>
      )}
      <div className="mt-3 text-xs font-semibold text-[#1E9E2A] flex items-center gap-1">Ver detalhes <ArrowRight className="h-3.5 w-3.5" /></div>
    </button>
  );
};
